import produce from 'immer';

import { formatRanking, formatNum } from '@/utils';
import { BadgeMintRecord } from '../types';

export const transBadgeMintRecord = (x: BadgeMintRecord) => {
  return produce(x, d => {
    d._follows = formatNum(d.user.follower_count, 0);
    d._tvf = formatRanking(d.tvf);
    d._networth = formatRanking(d.usd_value);
  });
};
